import "./App.css";
// 1. Impor biasa, tanpa ScrollRestoration
import { BrowserRouter, Routes, Route } from "react-router-dom"; 

// 2. Impor komponen baru Anda
import ScrollToTop from "./components/ScrollToTop"; // <-- Sesuaikan path jika perlu

import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Products } from "./pages/Products";
import { Contact } from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop /> {/* <-- 3. Letakkan komponen baru di sini */}
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;